import { BattlePlayerStatusType } from 'models/battles/BattlePlayerStatus';
import React from 'react';

export type StatusProps = {
	type: BattlePlayerStatusType;
	onClick?: () => void;
	children?: React.ReactNode;
};

export const Status = ({ type, onClick, children }: StatusProps) => {
	return (
		<div
			onClick={onClick}
			className={`d-flex flex-row align-items-center battlePlayerStatus battlePlayerStatus--${type}`}
		>
			<div className="battlePlayerStatus__icon"></div>
			<div className="battlePlayerStatus__text">{children}</div>
		</div>
	);
};

export default Status;
